<template>
	<div class="vaM_E" :class="{ flexW: ipts.length > 1 }">
		<div
			v-show="ipts.length > 1"
			class="w100pct mt3x mb1x bdSplitLine-top bd-dashed-top pt205x fsLv3"
		>
			{{ getLanguageStr("word1502", "输入项") }}
		</div>
		<div
			:class="{ 'pt1x pb1x w33pct mb05x': ipts.length > 1 }"
			v-for="(ipt, index) in ipts"
			:key="index"
		>
			<section v-if="ipt.type == 'none'"></section>
			<section class="flexW pl1x_E aiC" v-else-if="ipt.type == 'input'">
				<div
					class="cSub textCut"
					:class="ipts.length == 1 ? 'taR' : 'w100pct mb05x '"
					:title="
						ipts.length > 1
							? ipt.name
							: getLanguageStr('word1502+: ', '输入项: ')
					"
				>
					{{
						ipts.length > 1
							? ipt.name
							: getLanguageStr("word1502+: ", "输入项: ")
					}}
				</div>
				<div
					class="flexW aiC"
					:class="{ 'pr30pct w100pct': ipts.length > 1 }"
				>
					<!--<input type="text" :placeholder="ipt.placeholder" @keyup="inputReg" @focus="inputFocus" @blur="inputBlur" v-model="ipt.value" maxlength="100" class="w20x bdSub tra-fast sizeM" :class="{'error':showTips}" />-->
					<div class="flex100">
						<input-text
							class="w100pct"
							:placeholder="ipt.input.placeholder"
							@Focus="inputFocus(index)"
							@Blur="
								(v) => {
									inputBlur(index, v);
								}
							"
							verifyMethod=""
							v-model="ipt.value"
							:isError="ipt.input.inputErr.isError"
							:errorTip="ipt.input.inputErr.errorTip"
							:only="ipt.input.rule.only"
							:matchType="ipt.input.rule.matchType"
							:size="'s'"
						></input-text>
					</div>
				</div>
				<div class="w4x">{{ getOrderLanguage(ipt.input.unit[0]) }}</div>
			</section>
			<section class="flexW pl1x_E aiC" v-else-if="ipt.type == 'select'">
				<div
					class="w30pct cSub textCut"
					:class="ipts.length == 1 ? 'taR' : 'w100pct mb05x '"
					:title="ipts.length > 1 ? ipt.name : ''"
				>
					{{ ipts.length > 1 ? ipt.name : "" }}
				</div>
				<div
					class="flexW aiC"
					:class="{ 'pr30pct w100pct': ipts.length > 1 }"
				>
					<Select
						v-model="ipt.value"
						:bind-active="ipt.value"
						:list="ipt.select"
					></Select>
				</div>
			</section>
			<!-- <Select
				v-else-if="ipt.type == 'select'"
				v-model="ipt.value"
				:bindActive="ipt.value"
				:list="ipt.select"
			></Select> -->
			<vue-datepicker-local
				v-else-if="ipt.type == 'time'"
				v-model="ipt.value"
				class="datepicker"
				:format="ipt.format"
				:area="
					ipt.area
						? [
								new Date(ipt.area[0]).getTime(),
								new Date(ipt.area[1]).getTime(),
						  ]
						: null
				"
			></vue-datepicker-local>

			<section v-else-if="ipt.type == 'hm'">
				<Select v-model="ipt.valueH" :list="timeH"></Select>
				<Select v-model="ipt.valueM" :list="timeM"></Select>
			</section>
			<section v-else-if="ipt.type == 'hms'">
				<Select v-model="ipt.valueH" :list="timeH"></Select>
				<Select v-model="ipt.valueM" :list="timeM"></Select>
				<Select v-model="ipt.valueS" :list="timeS"></Select>
			</section>
			<section class="vaM_E" v-else-if="ipt.type == 'datehms'">
				<vue-datepicker-local
					v-model="ipt.value"
					class="datepicker"
					:format="'YYYY/MM/DD'"
				></vue-datepicker-local>
				<Select v-model="ipt.valueH" :list="timeH"></Select>
				<Select v-model="ipt.valueM" :list="timeM"></Select>
				<Select v-model="ipt.valueS" :list="timeS"></Select>
			</section>
		</div>
	</div>
</template>

<script>
import * as lib from "@/util/lib";
import * as orderConfig from "@/util/deviceOrderConfig";
import { getLanguageStr } from "@/util/language";

import Select from "@/components/common/ui/Select.vue";
import InputText from "@/components/common/ui/InputText.vue";

export default {
	name: "OrderInput",
	components: { Select, InputText },
	data() {
		return {
			ipts: [],
			setSelectIndex: 0,
			dateV: "",
			timeH: [
				{
					value: "",
					text: getLanguageStr("word806", "请选择"),
					token: true,
				},
				{ value: "00", text: "00" },
				{ value: "01", text: "01" },
				{ value: "02", text: "02" },
				{ value: "03", text: "03" },
				{ value: "04", text: "04" },
				{ value: "05", text: "05" },
				{ value: "06", text: "06" },
				{ value: "07", text: "07" },
				{ value: "08", text: "08" },
				{ value: "09", text: "09" },
				{ value: "10", text: "10" },
				{ value: "11", text: "11" },
				{ value: "12", text: "12" },
				{ value: "13", text: "13" },
				{ value: "14", text: "14" },
				{ value: "15", text: "15" },
				{ value: "16", text: "16" },
				{ value: "17", text: "17" },
				{ value: "18", text: "18" },
				{ value: "19", text: "19" },
				{ value: "20", text: "20" },
				{ value: "21", text: "21" },
				{ value: "22", text: "22" },
				{ value: "23", text: "23" },
			],
			timeM: [
				{
					value: "",
					text: getLanguageStr("word806", "请选择"),
					token: true,
				},
				{ value: "00", text: "00" },
				{ value: "01", text: "01" },
				{ value: "02", text: "02" },
				{ value: "03", text: "03" },
				{ value: "04", text: "04" },
				{ value: "05", text: "05" },
				{ value: "06", text: "06" },
				{ value: "07", text: "07" },
				{ value: "08", text: "08" },
				{ value: "09", text: "09" },
				{ value: "10", text: "10" },
				{ value: "11", text: "11" },
				{ value: "12", text: "12" },
				{ value: "13", text: "13" },
				{ value: "14", text: "14" },
				{ value: "15", text: "15" },
				{ value: "16", text: "16" },
				{ value: "17", text: "17" },
				{ value: "18", text: "18" },
				{ value: "19", text: "19" },
				{ value: "20", text: "20" },
				{ value: "21", text: "21" },
				{ value: "22", text: "22" },
				{ value: "23", text: "23" },
				{ value: "24", text: "24" },
				{ value: "25", text: "25" },
				{ value: "26", text: "26" },
				{ value: "27", text: "27" },
				{ value: "28", text: "28" },
				{ value: "29", text: "29" },
				{ value: "30", text: "30" },
				{ value: "31", text: "31" },
				{ value: "32", text: "32" },
				{ value: "33", text: "33" },
				{ value: "34", text: "34" },
				{ value: "35", text: "35" },
				{ value: "36", text: "36" },
				{ value: "37", text: "37" },
				{ value: "38", text: "38" },
				{ value: "39", text: "39" },
				{ value: "40", text: "40" },
				{ value: "41", text: "41" },
				{ value: "42", text: "42" },
				{ value: "43", text: "43" },
				{ value: "44", text: "44" },
				{ value: "45", text: "45" },
				{ value: "46", text: "46" },
				{ value: "47", text: "47" },
				{ value: "48", text: "48" },
				{ value: "49", text: "49" },
				{ value: "50", text: "60" },
				{ value: "51", text: "51" },
				{ value: "52", text: "52" },
				{ value: "53", text: "53" },
				{ value: "54", text: "54" },
				{ value: "55", text: "55" },
				{ value: "56", text: "56" },
				{ value: "57", text: "57" },
				{ value: "58", text: "58" },
				{ value: "59", text: "59" },
			],
			timeS: [
				{
					value: "",
					text: getLanguageStr("word806", "请选择"),
					token: true,
				},
				{ value: "00", text: "00" },
				{ value: "01", text: "01" },
				{ value: "02", text: "02" },
				{ value: "03", text: "03" },
				{ value: "04", text: "04" },
				{ value: "05", text: "05" },
				{ value: "06", text: "06" },
				{ value: "07", text: "07" },
				{ value: "08", text: "08" },
				{ value: "09", text: "09" },
				{ value: "10", text: "10" },
				{ value: "11", text: "11" },
				{ value: "12", text: "12" },
				{ value: "13", text: "13" },
				{ value: "14", text: "14" },
				{ value: "15", text: "15" },
				{ value: "16", text: "16" },
				{ value: "17", text: "17" },
				{ value: "18", text: "18" },
				{ value: "19", text: "19" },
				{ value: "20", text: "20" },
				{ value: "21", text: "21" },
				{ value: "22", text: "22" },
				{ value: "23", text: "23" },
				{ value: "24", text: "24" },
				{ value: "25", text: "25" },
				{ value: "26", text: "26" },
				{ value: "27", text: "27" },
				{ value: "28", text: "28" },
				{ value: "29", text: "29" },
				{ value: "30", text: "30" },
				{ value: "31", text: "31" },
				{ value: "32", text: "32" },
				{ value: "33", text: "33" },
				{ value: "34", text: "34" },
				{ value: "35", text: "35" },
				{ value: "36", text: "36" },
				{ value: "37", text: "37" },
				{ value: "38", text: "38" },
				{ value: "39", text: "39" },
				{ value: "40", text: "40" },
				{ value: "41", text: "41" },
				{ value: "42", text: "42" },
				{ value: "43", text: "43" },
				{ value: "44", text: "44" },
				{ value: "45", text: "45" },
				{ value: "46", text: "46" },
				{ value: "47", text: "47" },
				{ value: "48", text: "48" },
				{ value: "49", text: "49" },
				{ value: "50", text: "60" },
				{ value: "51", text: "51" },
				{ value: "52", text: "52" },
				{ value: "53", text: "53" },
				{ value: "54", text: "54" },
				{ value: "55", text: "55" },
				{ value: "56", text: "56" },
				{ value: "57", text: "57" },
				{ value: "58", text: "58" },
				{ value: "59", text: "59" },
			],
		};
	},
	methods: {
		getLanguageStr,
		getOrderLanguage: orderConfig.getLanguage,
		timeFormat: lib.timeFormat,
		init(ipt) {
			if (ipt && ipt.length) {
				let list = _.cloneDeep(ipt);
				$.each(list, (index, val) => {
					val.name = orderConfig.getLanguage(val.name[0]);
					if (val.select) {
						val.select = orderConfig.getLanguageList(val.select);
					}
					if (val.type == "time") {
						val.value = new Date();
					}
				});
				this.ipts = list;
			} else this.ipts = [];
		},
		//		inputReg(){
		//			let val = this.ipt.value +'';
		//			let chat = val.substr(val.length-1,1);
		//			if(this.ipt.input.rule.chats.indexOf(chat) == -1) val=val.substr(0,val.Length-1);
		//			if(this.ipt.input.rule.type == 'number'){
		//			}
		//			this.ipt.value = orderConfig.iptNumber(this.ipt.value,this.ipt.input.rule);
		//
		//			this.ipt.value = val;
		//		},
		inputFocus(index) {
			this.ipts[index].input.inputErr.isError.error = true;
			this.ipts[index].input.inputErr.errorTip =
				this.ipts[index].input.inputTips &&
				this.ipts[index].input.inputTips.length > 1
					? orderConfig.getLanguage(
							this.ipts[index].input.inputTips[0]
					  )
					: this.ipts[index].input.inputTips || "";
		},
		inputBlur(index, value) {
			let matchArea = false; // this.ipts[index].value
			if (this.ipts[index].input.rule.areas) {
				this.ipts[index].input.rule.areas.map((item) => {
					if (Number(value) >= item[0] && Number(value) <= item[1]) {
						matchArea = true;
					}
				});
			} else if (this.ipts[index].input.rule.regular) {
				if (
					lib.validValue(value, [this.ipts[index].input.rule.regular])
						.allClear
				) {
					matchArea = true;
				}
			} else {
				// 没有设置，作为无需校验
				matchArea = true;
			}
			if (value == "" || matchArea) {
				this.ipts[index].input.inputErr.isError.error = false;
				this.ipts[index].input.inputErr.errorTip = "";
			}
		},
		orderInputCheck() {
			let cr = true;
			this.ipts.map((ipt) => {
				if (cr) {
					switch (ipt.type) {
						case "input":
							if (ipt.input.inputErr.isError.error) {
								cr = false;
								this.$notify(
									ipt.name +
										" " +
										getLanguageStr(
											"command12",
											"输入项有误"
										)
								);
							} else if (ipt.value === "") {
								cr = false;
								this.$notify(
									ipt.name +
										" " +
										getLanguageStr(
											"command13",
											"输入项不能为空"
										)
								);
							}
							break;
						case "select":
							if (
								ipt.value === "" ||
								ipt.value == undefined ||
								ipt.value == null
							) {
								this.$notify(
									getLanguageStr("word806", "请选择") +
										ipt.name
								);
								cr = false;
							}
							break;
						case "date":
							if (ipt.value == "") {
								this.$notify(
									getLanguageStr("word806", "请选择") +
										ipt.name
								);
								cr = false;
							}
							break;
						case "month":
							if (ipt.value == "") {
								this.$notify(
									getLanguageStr("word806", "请选择") +
										ipt.name
								);
								cr = false;
							}
							break;
						case "hm":
							if (!ipt.valueH || !ipt.valueM) {
								this.$notify(
									getLanguageStr("word806", "请选择") +
										ipt.name
								);
								cr = false;
							}
							break;
						case "hms":
							if (!ipt.valueH || !ipt.valueM || !ipt.valueS) {
								this.$notify(
									getLanguageStr("word806", "请选择") +
										ipt.name
								);
								cr = false;
							}
							break;
						case "datehms":
							if (
								!ipt.value ||
								!ipt.valueH ||
								!ipt.valueM ||
								!ipt.valueS
							) {
								this.$notify(
									getLanguageStr("word806", "请选择") +
										ipt.name
								);
								cr = false;
							}
							break;
						default:
							break;
					}
					if (cr && Number(this.orderTimeout) == 0) {
						this.$notify(
							getLanguageStr("phrase847", "请输入超时时间")
						);
						cr = false;
					}
				}
			});
			return cr;
		},
		getOrderInputValue() {
			let r = null;
			let err = false;
			if (this.orderInputCheck()) {
				return this.ipts;
			} else {
				return false;
			}
		},
	},
	computed: {
		// getConfigOptionI18nList:function(){
		// 	return this.ipts?orderConfig.getLanguageList(this.ipts.select||[]):[];
		// }
	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
.datepicker {
	width: 15em;
	height: 2.5em;
	line-height: 2.5em;
}
.errorTip,
.infoTip {
	padding: 0.1em 0.5em 0 0.5em;
	opacity: 1;
	&.errorTip-right {
		line-height: 2;
	}
	&.errorTip-static {
		padding: {
			top: 0.3em;
		}
		position: relative;
		text-align: left;
	}
}
.inputBtnPlug {
	height: 60%;
	position: absolute;
	top: 20%;
	right: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/device/device/part/OrderInput.vue